__turbopack_context__.v({
  "articles": "iFg2ca_articles",
  "card": "iFg2ca_card",
  "publishDate": "iFg2ca_publishDate",
  "source": "iFg2ca_source",
  "title": "iFg2ca_title",
});
